(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hyssop-home-v7"]) return;
  try {
    
  class HyssopBrowseV7 {
    constructor(section) {
      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-hyssop-browse-tab]'));
      this.panels = Array.from(section.querySelectorAll('[data-hyssop-browse-panel]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.hyssopBrowseTab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    select(name) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.hyssopBrowseTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const active = panel.dataset.hyssopBrowsePanel === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    onKeydown(event, index) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
        return;
      }

      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (index + direction + this.tabs.length) % this.tabs.length;
      const nextTab = this.tabs[nextIndex];
      nextTab.focus();
      this.select(nextTab.dataset.hyssopBrowseTab);
    }
  }

  document.querySelectorAll('[data-hyssop-browse]').forEach((section) => {
    new HyssopBrowseV7(section);
  });

  } catch(e) { console.error(e); }
})();
})();
